export default [{
  mainButton: {
    name: 'departments-settings',
    label: '<%shop_plural_V_Upper%>',
    goTo: '/settings/departments/',
    tooltip: 'Просмотр и изменение параметров <%shop_plural_R%>'
  },
  fastButtons: [{
    name: 'timetableTemplateAdd',
    label: 'добавить <%shop_singular_I%>',
    goTo: '/settings/departments/?modal=DepSettings~-1'
  }],
  filterModalName: 'settingsShops'
}, {
  mainButton: {
    name: 'positions',
    label: 'Должности<br>сотрудников',
    goTo: '/settings/positions/',
    tooltip: 'Просмотр и изменение должностей сотрудников'
  },
  fastButtons: [{
    name: 'positionAdd',
    label: 'добавить должность',
    goTo: '/settings/positions/?modal=Position~-1'
  }],
  filterModalName: 'settingsPositions'
}, {
  mainButton: {
    name: 'accessGroups',
    label: 'Группы<br>доступа',
    goTo: '/settings/access-groups/',
    tooltip: 'Просмотр и изменение групп доступа'
  },
  fastButtons: [{
    name: 'accessGroupAdd',
    label: 'добавить группу доступа',
    goTo: '/settings/access-groups/?modal=AccessGroup~-1'
  }, {
    name: 'blockWorkingDaysUpdate',
    label: 'Ограничение на редактирование смен',
    goTo: '/settings/access-groups/?modal=BlockWorkingDays'
  }],
  filterModalName: 'settingsAccessGroups'
}, {
  mainButton: {
    name: 'businessDrivers',
    label: 'Бизнес<br>драйверы',
    goTo: '/settings/business-drivers/',
    tooltip: 'Просмотр и изменение бизнес-драйверов'
  },
  fastButtons: [{
    name: 'businessDriverAdd',
    label: 'добавить бизнес-драйвер',
    goTo: '/settings/business-drivers/?modal=BusinessDriver~-1'
  }],
  filterModalName: 'settingsBusinessDrivers'
}, {
  mainButton: {
    name: 'operations',
    label: 'Операции',
    goTo: '/settings/operations/',
    tooltip: 'Просмотр и изменение операций'
  },
  fastButtons: [{
    name: 'operationAdd',
    label: 'добавить операцию',
    goTo: '/settings/operations/?modal=Operation~-1'
  }],
  filterModalName: 'settingsOperations'
}, {
  mainButton: {
    name: 'workTypes',
    label: 'Типы работ',
    goTo: '/settings/work-types/',
    tooltip: 'Просмотр и изменение типов работ'
  },
  fastButtons: [{
    name: 'workTypeAdd',
    label: 'добавить тип работ',
    goTo: '/settings/work-types/?modal=WorkType~-1'
  }],
  filterModalName: 'settingsWorkTypes'
}, {
  mainButton: {
    name: 'loadTemplates',
    label: 'Шаблоны<br>нагрузки',
    goTo: '/settings/load-templates/',
    tooltip: 'Просмотр и изменение шаблонов нагрузки'
  },
  fastButtons: [{
    name: 'loadTemplateAdd',
    label: 'добавить шаблон нагрузки',
    goTo: '/settings/load-templates/?modal=LoadTemplate~-1'
  }],
  filterModalName: 'settingsLoadTemplates'
}, {
  mainButton: {
    name: 'timetable-templates',
    label: 'Шаблоны<br>расписания',
    goTo: '/settings/timetable-templates/',
    tooltip: 'Просмотр и изменение шаблонов расписания'
  },
  fastButtons: [{
    name: 'timetableTemplateAdd',
    label: 'добавить шаблон расписания',
    goTo: '/settings/timetable-templates/?modal=TimetableTemplate~-1'
  }],
  filterModalName: 'settingsTimetableTemplates'
}, {
  mainButton: {
    name: 'tickpoints',
    label: 'Точки отметок',
    goTo: '/settings/tickpoints/',
    tooltip: 'Просмотр и изменение точек отметок'
  },
  fastButtons: [{
    name: 'tickpointAdd',
    label: 'добавить точку отметок',
    goTo: '/settings/tickpoints/?modal=Tickpoint~-1'
  }],
  filterModalName: 'settingsTickpoints'
}];